import { IEntityInfo, NSARouterMakerResult } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { FilterItem, IStorageLocal, NamingConvention } from "namirasoft-core";
import { HistoryCreateRow, HistoryRow } from "namirasoft-history";
import { NamirasoftMap } from "namirasoft-site-map";
import { BaseColumnFormatter, DateTimeFormatter, IDFormatter, JsonFormatter, StringFormatter, StringFormatterSizeType } from "namirasoft-site-react";
import { HistoryRouterProps } from "./HistoryRouterProps";
import { HistoryRoutes } from './HistoryRoutes';

export class HistoryEntities
{
	static history(props: NSARouterMakerResult & HistoryRouterProps, extra_filters: FilterItem[]): IEntityInfo<HistoryRow, HistoryCreateRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
		return {
			product_id: ProductUUID.NAMIRASOFT_HISTORY,
			name: "History",
			tables: [{ table: namirasoft.history.tables.history, required: true }],
			client: {
				getColumns: () =>
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.history.tables.history.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.history.tables.history.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.history.tables.history.columns.session_id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.history.tables.history.columns.product_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.history.tables.history.columns.entity_name, new StringFormatter(StringFormatterSizeType.TwoWords, NamingConvention.Pascal_Case_Space)),
						BaseColumnFormatter.getColumn(namirasoft.history.tables.history.columns.entity_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.history.tables.history.columns.action, new StringFormatter(StringFormatterSizeType.TwoWords)),
						BaseColumnFormatter.getColumn(namirasoft.history.tables.history.columns.old_value, new JsonFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.history.tables.history.columns.new_value, new JsonFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.history.tables.history.columns.created_at, new DateTimeFormatter()),
					];
				},
				getListURL: () => HistoryRoutes.HistoryList,
				getNewURL: null,
				getCopyURL: null,
				getEditURL: null,
				getViewURL: (id: string) => HistoryRoutes.HistoryView(id),
			},
			server: {
				value_list: props.servers.history.value.List,
				get: props.servers.history.history.Get,
				list: (filters, page, size, sorts, all_workspaces) => { return props.servers.history.history.List([...(filters ?? []), ...extra_filters], page, size, sorts, all_workspaces); },
				create: null,
				update: null,
				delete: null,
			}
		};
	}
}